import { Team__Aliados } from "../teams/Aliados";
import { Team__Cerveceros_MAIN } from "../teams/Cerveceros_MAIN";
import { Team__Apaches } from "../teams/Apaches";
import { Team__MeanMachine } from "../teams/MeanMachine";
import { Team__Nogaleros } from "../teams/Nogaleros";
import { Team__BallBrothers } from "../teams/BallBrothers";
import { Team__UT } from "../teams/UT";
import { Team__XLobos } from "../teams/XLobos";

const Aliados = {
  team: Team__Aliados,
  playingPlayers: [],

  goals: 47,
  penaltyGoals: 0,
  isWinner: false,
};

const Apaches = {
  team: Team__Apaches,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros_MAIN,
  playingPlayers: [],

  goals: 41,
  penaltyGoals: 0,
  isWinner: false,
};

const MeanMachine = {
  team: Team__MeanMachine,
  playingPlayers: [],

  goals: 36,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleros = {
  team: Team__Nogaleros,
  playingPlayers: [],

  goals: 49,
  penaltyGoals: 0,
  isWinner: false,
};

const BallBrothers = {
  team: Team__BallBrothers,
  playingPlayers: [],

  goals: 63,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UT,
  playingPlayers: [],

  goals: 65,
  penaltyGoals: 0,
  isWinner: false,
};

const XLobos = {
  team: Team__XLobos,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada2 = {
  jornadaPosition: 2,
  matches: [
    {
      team1: Cerveceros,
      team2: MeanMachine,

      isCompleted: true,
      isPlaying: true,
      day: "Martes",
      date: "2025-07-29",
      time: "18:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: UTPaquime,
      team2: BallBrothers,

      isCompleted: true,
      isPlaying: true,
      day: "Martes",
      date: "2025-07-29",
      time: "19:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Aliados,
      team2: Nogaleros,

      isCompleted: true,
      isPlaying: true,
      day: "Martes",
      date: "2025-07-29",
      time: "20:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
